// extracted by mini-css-extract-plugin
export default {"videoContainer":"VideoPlayer_videoContainer__OWAzt","playPauseButton":"VideoPlayer_playPauseButton__knwa4"};